<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="烟价管理">
      <template>
        <el-button size="small" type="primary" @click="handleSave"
          >保存修改</el-button
          > 
          <el-button size="small" type="primary" @click="handleImportClick"
          >批量导入</el-button
          >
          <el-button size="small" type="primary" @click="handleDownloadTemplate"
          >下载模板</el-button
          >
          <el-button size="small" type="primary" @click="handleExportAll" style="margin-left: 10px"
          >全部导出</el-button
          >
          <el-button size="small" type="primary" @click="handleExportSelected" :disabled="selectedRows.length === 0"
          >勾选导出</el-button
          >
      </template>
    </pageTitle>
    
    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:otherOperations>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-refresh"
          @click="handleReset"
        >重置</el-button>
      </template>
    </basicList>
    
    <div class="table-container">
      <el-table
        :data="basicListconfig.data"
        border
        :height="basicListconfig.height"
        v-loading="basicListconfig.loading"
        header-cell-class-name="headerCellStyle"
        cell-class-name="cellStyle"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="item_id" label="ID" width="80"></el-table-column>
        <el-table-column prop="name" label="商品名称" min-width="150"></el-table-column>
        <el-table-column prop="item_number" label="商品编码" width="120"></el-table-column>
        <el-table-column prop="price_instock" label="分销价" width="180">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.price_instock"
              :precision="2"
              :step="0.01"
              :min="0"
              controls-position="right"
              size="small"
              @change="handlePriceChange(scope.row, 'price_instock')"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="price_outstock" label="批发价" width="180">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.price_outstock"
              :precision="2"
              :step="0.01"
              :min="0"
              controls-position="right"
              size="small"
              @change="handlePriceChange(scope.row, 'price_outstock')"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="price_web" label="加盟价" width="180">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.price_web"
              :precision="2"
              :step="0.01"
              :min="0"
              controls-position="right"
              size="small"
              @change="handlePriceChange(scope.row, 'price_web')"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="price_member" label="权限价" width="180">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.price_member"
              :precision="2"
              :step="0.01"
              :min="0"
              controls-position="right"
              size="small"
              @change="handlePriceChange(scope.row, 'price_member')"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="price_distribution" label="门店价" width="180">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.price_distribution"
              :precision="2"
              :step="0.01"
              :min="0"
              controls-position="right"
              size="small"
              @change="handlePriceChange(scope.row, 'price_distribution')"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="sell_price" label="出货价(整条)" width="180">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.sell_price"
              :precision="2"
              :step="0.01"
              :min="0"
              controls-position="right"
              size="small"
              @change="handlePriceChange(scope.row, 'sell_price')"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="receive_price" label="收货价(整条)" width="180">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.receive_price"
              :precision="2"
              :step="0.01"
              :min="0"
              controls-position="right"
              size="small"
              @change="handlePriceChange(scope.row, 'receive_price')"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="price_instock_time" label="分销价修改时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.price_instock_time || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price_outstock_time" label="批发价修改时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.price_outstock_time || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price_web_time" label="加盟价修改时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.price_web_time || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price_member_time" label="权限价修改时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.price_member_time || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price_distribution_time" label="门店价修改时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.price_distribution_time || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sell_price_time" label="出货价修改时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.sell_price_time || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="receive_price_time" label="收货价修改时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.receive_price_time || '' }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>

    <!-- 批量导入对话框 -->
    <el-dialog
      title="批量导入烟价数据"
      :visible.sync="importDialogVisible"
      width="500px"
    >
      <div class="import-container">
        <div class="upload-area" @click="triggerFileInput">
          <i class="el-icon-upload"></i>
          <div class="upload-text">
            将Excel文件拖到此处，或<em>点击上传</em>
          </div>
        </div>
        <input
          type="file"
          ref="fileInput"
          style="display: none"
          accept=".xlsx,.xls,.csv"
          @change="handleFileChange"
        />
        
        <div v-if="importFileName" class="import-file-name">
          <i class="el-icon-document"></i>
          已选择: {{ importFileName }}
        </div>
        
        <div class="import-actions">
          <el-button @click="handleDownloadTemplate">下载模板</el-button>
          <el-button type="primary" @click="confirmImport" :disabled="!importFile">确认导入</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageTitle from '@/components/pageTitle'
import basicList from '@/components/basicList'
import request from '@/utils/request'
import axios from 'axios'
import { getSession } from '@/utils/cookie'
import { getRoles } from "@/utils"
import {
  smokePriceGetList,
  smokePriceBatchUpdate,
  smokePriceImportExcel
} from '@/api/smoke'

export default {
  name: 'smokeManagement',
  components: {
    pageTitle,
    basicList
  },
  data() {
    return {
      tableData: [],
      allTableData: [],
      loading: false,
      tableHeight: "calc(100vh - 350px)",
      basicListconfig: {
        table: true,
        loading: false,
        height: "calc(100vh - 350px)",
        search: [
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          {
            label: "分销价修改日期",
            type: "daterange",
            key: "filter_date_instock",
          },
          {
            label: "批发价修改日期",
            type: "daterange",
            key: "filter_date_outstock",
          },
          {
            label: "加盟价修改日期",
            type: "daterange",
            key: "filter_date_web",
          },
          {
            label: "权限价修改日期",
            type: "daterange",
            key: "filter_date_member",
          },
          {
            label: "门店价修改日期",
            type: "daterange",
            key: "filter_date_distribution",
          },
          {
            label: "出货价修改日期",
            type: "daterange",
            key: "filter_date_sell",
          },
          {
            label: "收货价修改日期",
            type: "daterange",
            key: "filter_date_receive",
          },
        ],
        data: [],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, {
          page: 1,
          limit: 10
        }),
      },
      currentPage: 1,
      pageSize: 10,
      pageTotal: 0,
      total: 0,
      modifiedRows: new Set(),
      modifiedFields: new Map(),
      searchKeyword: '',
      importDialogVisible: false,
      importFile: null,
      importFileName: '',
      uploadAction: '',
      selectedRows: []
    }
  },
  mounted() {
    const apiBase = process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API.replace(/"/g, '') : 'http://uaterp.zuizhenshi.cn';
    this.uploadAction = apiBase + '/admin/Smoke_price_management/import_excel';
    this.loadData()
  },
  beforeDestroy() {
  },
  methods: {
    searchEvent(searchForm) {
      this.basicListconfig.searchParameters.page = 1
      this.loadData(searchForm)
    },
    loadData(searchForm = {}) {
      this.basicListconfig.loading = true
      const searchParams = Object.assign({}, this.basicListconfig.searchParameters, searchForm)
      
      const filter_date_instock = searchParams.filter_date_instock || []
      const filter_date_outstock = searchParams.filter_date_outstock || []
      const filter_date_web = searchParams.filter_date_web || []
      const filter_date_member = searchParams.filter_date_member || []
      const filter_date_distribution = searchParams.filter_date_distribution || []
      const filter_date_sell = searchParams.filter_date_sell || []
      const filter_date_receive = searchParams.filter_date_receive || []
      
      smokePriceGetList({
        page: searchParams.page,
        limit: searchParams.limit,
        search: searchParams.keywords,
        comp_id: JSON.parse(getRoles()).comp_id,
        filter_date_instock_start: filter_date_instock[0] || '',
        filter_date_instock_end: filter_date_instock[1] || '',
        filter_date_outstock_start: filter_date_outstock[0] || '',
        filter_date_outstock_end: filter_date_outstock[1] || '',
        filter_date_web_start: filter_date_web[0] || '',
        filter_date_web_end: filter_date_web[1] || '',
        filter_date_member_start: filter_date_member[0] || '',
        filter_date_member_end: filter_date_member[1] || '',
        filter_date_distribution_start: filter_date_distribution[0] || '',
        filter_date_distribution_end: filter_date_distribution[1] || '',
        filter_date_sell_start: filter_date_sell[0] || '',
        filter_date_sell_end: filter_date_sell[1] || '',
        filter_date_receive_start: filter_date_receive[0] || '',
        filter_date_receive_end: filter_date_receive[1] || ''
      }).then(response => {
        if (response.code === 1) {
          this.tableData = response.data || [];
          this.allTableData = response.data || [];
          this.basicListconfig.data = response.data || [];
          this.basicListconfig.total = parseInt(response.count) || 0;
          this.pageTotal = parseInt(response.count) || 0;
        }
      }).catch(error => {
        console.error('加载数据失败', error);
        this.$message.error('加载数据失败: ' + (error.message || '未知错误'));
        this.tableData = [];
        this.allTableData = [];
        this.basicListconfig.data = [];
        this.basicListconfig.total = 0;
      }).finally(() => {
        this.basicListconfig.loading = false;
      });
    },
    handleSearch() {
      this.basicListconfig.searchParameters.page = 1
      this.loadData()
    },
    handleReset() {
      this.basicListconfig.searchParameters = Object.assign({}, {
        page: 1,
        limit: 10
      })
      this.currentPage = 1
      this.pageSize = 10
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.basicListconfig.searchParameters.limit = val
      this.basicListconfig.searchParameters.page = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.basicListconfig.searchParameters.page = val
      this.loadData()
    },
    handlePriceChange(row, priceField) {
      this.modifiedRows.add(row.item_id);
      if (!this.modifiedFields.has(row.item_id)) {
        this.modifiedFields.set(row.item_id, new Set());
      }
      this.modifiedFields.get(row.item_id).add(priceField);
    },
    handleSave() {
      if (this.modifiedRows.size === 0) {
        this.$message.warning('没有修改的数据')
        return
      }
      
      // 收集修改的数据
      const updates = [];
      const now = new Date().toISOString().replace('T', ' ').substring(0, 19);
      
      this.modifiedRows.forEach(item_id => {
        const row = this.allTableData.find(item => item.item_id === item_id);
        if (row) {
          const update = { 
            id: row.id, 
            item_id: row.item_id,
            product_name: row.name,
            product_code: row.item_number
          };
          const fields = this.modifiedFields.get(item_id) || new Set();
          
          // 只添加有修改的字段，并添加修改时间
          if (fields.has('price_instock')) {
            update.price_instock = row.price_instock;
            update.price_instock_time = now;
          }
          if (fields.has('price_outstock')) {
            update.price_outstock = row.price_outstock;
            update.price_outstock_time = now;
          }
          if (fields.has('price_web')) {
            update.price_web = row.price_web;
            update.price_web_time = now;
          }
          if (fields.has('price_member')) {
            update.price_member = row.price_member;
            update.price_member_time = now;
          }
          if (fields.has('price_distribution')) {
            update.price_distribution = row.price_distribution;
            update.price_distribution_time = now;
          }
          if (fields.has('sell_price')) {
            update.sell_price = row.sell_price;
            update.sell_price_time = now;
          }
          if (fields.has('receive_price')) {
            update.receive_price = row.receive_price;
            update.receive_price_time = now;
          }
          
          updates.push(update);
        }
      });
      
      if (updates.length === 0) {
        this.$message.warning('没有修改的数据')
        return
      }
      
      smokePriceBatchUpdate({
        data: JSON.stringify(updates),
        comp_id: JSON.parse(getRoles()).comp_id
      }).then(response => {
        if (response.code === 1) {
          this.$message.success(`成功保存 ${this.modifiedRows.size} 条数据`);
          this.modifiedRows.clear();
          this.modifiedFields.clear();
          this.loadData();
        } else {
          this.$message.error('保存失败: ' + response.msg);
        }
      }).catch(error => {
        console.error('保存失败', error);
        this.$message.error('保存失败: ' + (error.message || '未知错误'));
      });
    },
    getPriceLabel(priceField) {
      const labels = {
        price_instock: '分销价',
        price_outstock: '批发价',
        price_web: '加盟价',
        price_member: '权限价',
        price_distribution: '门店价',
        price_out: '出货价',
        price_in: '收货价'
      }
      return labels[priceField] || priceField
    },  
    // 批量导入相关方法
    handleImportClick() {
      this.importDialogVisible = true;
      this.importFile = null;
    },
    
    beforeUpload(file) {
      this.importFile = file;
      return false; // 禁用自动上传，我们将手动处理
    },
    
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      
      const fileType = file.type || '';
      const fileName = file.name.toLowerCase();
      const isExcelByType = fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                           fileType === 'application/vnd.ms-excel';
      const isExcelByExt = fileName.endsWith('.xlsx') || 
                          fileName.endsWith('.xls') ||
                          fileName.endsWith('.csv');
      const isExcel = isExcelByType || isExcelByExt;
      
      if (!isExcel) {
        this.$message.error('只能上传Excel文件或CSV文件!');
        this.importFile = null;
        this.importFileName = '';
        return;
      }
      
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!');
        this.importFile = null;
        this.importFileName = '';
        return;
      }
      
      this.importFile = file;
      this.importFileName = file.name;
      this.$message.success('文件已选择: ' + file.name);
    },
    
    handleDownloadTemplate() {
      const apiBase = process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API.replace(/"/g, '') : 'http://uaterp.zuizhenshi.cn';
      const url = `${apiBase}/admin/Smoke_price_management/get_template?comp_id=${JSON.parse(getRoles()).comp_id}`;
      window.open(url, '_blank');
    },
    
    confirmImport() {
      if (!this.importFile) {
        this.$message.warning('请先选择要导入的Excel文件');
        return;
      }
      
      const loading = this.$loading({
        lock: true,
        text: '正在导入...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      const formData = new FormData();
      formData.append('file', this.importFile);
      formData.append('comp_id', JSON.parse(getRoles()).comp_id);
      
      smokePriceImportExcel(formData).then(response => {
        loading.close();
        if (response.code === 1) {
          this.$message.success('导入成功');
          this.importDialogVisible = false;
          this.loadData();
        } else {
          this.$message.error('导入失败: ' + response.msg);
        }
      }).catch(error => {
        loading.close();
        console.error('导入失败', error);
        this.$message.error('导入失败: ' + (error.message || '未知错误'));
      });
    },
    
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    
    handleExportAll() {
      const apiBase = process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API.replace(/"/g, '') : 'http://uaterp.zuizhenshi.cn';
      const url = `${apiBase}/admin/Smoke_price_management/export_excel?comp_id=${JSON.parse(getRoles()).comp_id}`;
      window.open(url, '_blank');
    },
    
    handleExportSelected() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要导出的数据');
        return;
      }
      
      const apiBase = process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API.replace(/"/g, '') : 'http://uaterp.zuizhenshi.cn';
      const itemIds = this.selectedRows.map(row => row.item_id).join(',');
      const url = `${apiBase}/admin/Smoke_price_management/export_excel?comp_id=${JSON.parse(getRoles()).comp_id}&item_ids=${itemIds}`;
      window.open(url, '_blank');
    },  
  }
}
</script>

<style scoped>
.search-container {
  padding: 15px 20px;
  background: #fff;
  margin-top: 2px;
  text-align: left;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.search-container .el-input {
  margin-right: 10px;
}

.searchDomain {
  padding: 10px 20px;
  background: rgba(243, 248, 255, 0.5);
  margin-bottom: 2px;
}

.searchDomain .el-form-item {
  margin-bottom: 0;
  margin-right: 10px;
}

.searchDomain .el-input,
.searchDomain .el-select,
.searchDomain .el-date-editor {
  width: 140px;
}

.headerCellStyle .cell {
  color: #0A1B33;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
}

.cellStyle .cell {
  color: #5F7092;
  font-size: 14px;
  font-weight: 400;
}

.table-container {
  padding: 15px 20px;
  background: #fff;
  margin-top: 2px;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}

.pagination-container {
  padding: 15px 20px;
  background: #fff;
  border-radius: 0 0 6px 6px;
}

.el-input-number {
  width: 100%;
}

.import-container {
  padding: 20px;
  text-align: center;
}

.upload-area {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  background: #fafafa;
  padding: 40px 20px;
  cursor: pointer;
  transition: border-color 0.3s;
}

.upload-area:hover {
  border-color: #409eff;
}

.upload-area i {
  font-size: 48px;
  color: #8c939d;
  margin-bottom: 10px;
}

.upload-text {
  font-size: 14px;
  color: #8c939d;
}

.upload-text em {
  color: #409eff;
  font-style: normal;
}

.import-file-name {
  margin-top: 15px;
  padding: 10px 15px;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  color: #67c23a;
  font-size: 14px;
}

.import-file-name i {
  margin-right: 5px;
}

.import-actions {
  margin-top: 20px;
  text-align: center;
}

.import-actions .el-button {
  margin: 0 10px;
}

.el-table {
  border-radius: 6px;
  overflow: hidden;
}

.el-table th {
  background-color: #fafafa;
  color: #606266;
  font-weight: 600;
}

.table-footer {
  padding: 15px 20px;
  text-align: right;
}

.moduleStyle {
  background: #ffffff;
  min-height: calc(100vh - 60px); 
}

.minHeight {
  min-height: calc(100vh - 60px);
}
</style>


// WEBPACK FOOTER //
// src/views/smokeManagement/index.vue